module.exports = __webpack_public_path__ + "img/app_tupuente.5a4120d7.png";